import React from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

const SURFACE_COLOR = "#1B1B1B";
const BORDER_COLOR = "rgba(255, 255, 255, 0.12)";
const TEXT_COLOR = "#FFFFFF";
const ACCENT_COLOR = "#0FD9FF";
const ON_ACCENT_COLOR = "#000000";

interface SessionExpiredModalCstProps {
  open: boolean;
  onConfirm: () => void;
}

const SessionExpiredModalCst: React.FC<SessionExpiredModalCstProps> = ({
  open,
  onConfirm,
}) => {
  const { t } = useTranslation("sessionExpired");

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: SURFACE_COLOR,
          backgroundImage: "none",
          border: `1px solid ${BORDER_COLOR}`,
          borderRadius: "16px",
          padding: "32px 24px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <TriangleAlert size={40} color={ACCENT_COLOR} />
        <Typography
          sx={{ fontSize: "20px", fontWeight: 700, color: TEXT_COLOR }}
        >
          {t("title")}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: TEXT_COLOR }}>
          {t("description")}
        </Typography>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            mt: 1,
            height: "40px",
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "8px",
            backgroundColor: ACCENT_COLOR,
            color: ON_ACCENT_COLOR,
            "&:hover": { backgroundColor: ACCENT_COLOR, opacity: 0.9 },
          }}
        >
          {t("cta")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default SessionExpiredModalCst;
